export default __webpack_public_path__ + "static/media/keto_foods@3x.911a7670.jpg";